import actionTypes from 'redux/actions/actionTypes';
import initialState from 'redux/initialState';

import { Encumbrance } from 'types';

import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

type EncumbranceAction = {
  type: string;
  encumbrances?: Encumbrance[];
  encumbrance?: Encumbrance;
  encumbranceId?: string;
};

const resetStateSociety = (): Encumbrance[] => initialState.encumbrances;

const createEncumbrance = (
  encumbrances: Encumbrance[],
  action: EncumbranceAction
): Encumbrance[] =>
  action.encumbrance ? [...encumbrances, action.encumbrance] : encumbrances;

const getEncumbrances = (action: EncumbranceAction): Encumbrance[] =>
  action.encumbrances || [];

const updateEncumbrance = (
  encumbrances: Encumbrance[],
  action: EncumbranceAction
): Encumbrance[] =>
  encumbrances
    ?.map((encumbrance: Encumbrance) =>
      encumbrance._id === action.encumbrance?._id
        ? action.encumbrance
        : encumbrance
    )
    .filter(
      (encumbrance): encumbrance is Encumbrance => encumbrance !== undefined
    );

const deleteEncumbrance = (
  encumbrances: Encumbrance[],
  action: EncumbranceAction
): Encumbrance[] =>
  encumbrances?.filter(
    (encumbrance: Encumbrance) => encumbrance._id !== action.encumbranceId
  );

const reducer = (
  encumbrances: Encumbrance[] = initialState.encumbrances,
  action: EncumbranceAction
) => {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.CREATE_ENCUMBRANCE:
      return createEncumbrance(encumbrances, action);

    case actionTypes.GET_ENCUMBRANCES:
      return getEncumbrances(action);

    case actionTypes.UPDATE_ENCUMBRANCE:
      return updateEncumbrance(encumbrances, action);

    case actionTypes.DELETE_ENCUMBRANCE:
      return deleteEncumbrance(encumbrances, action);

    default:
      return encumbrances;
  }
};

export default reducer;
